export default function Logo({ size = 36, className = "" }) {
  // VizionCast lightning Z mark — sharp Swiss aesthetic, IKB on white.
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="VizionCast"
    >
      <rect width="64" height="64" fill="#0033FF" />
      {/* Lightning Z mark + eye dot suggesting vision */}
      <path d="M16 14 H46 L30 32 H46 L18 50 L34 32 H16 Z" fill="#FFFFFF" />
      <circle cx="48" cy="16" r="3.5" fill="#FFB800" />
    </svg>
  );
}
